import { useNavigate } from "react-router-dom";
import Reveal from "../Reveal";

export default function TeaserBand() {
    const navigate = useNavigate();

    return (
        <section className="bg-navy text-cream" data-testid="teaser-band">
            <div className="container-luxe py-20 sm:py-24 grid gap-10 lg:grid-cols-12 items-center">
                <div className="lg:col-span-7">
                    <Reveal>
                        <p className="eyebrow mb-5">The Gold Standard of Private Guiding</p>
                        <h2 className="font-serif text-3xl sm:text-4xl leading-snug">
                            <span className="italic text-gold">HIT but HINT</span> — he is there, but he is{" "}
                            <span className="italic text-gold">not there.</span>
                        </h2>
                        <p className="mt-5 max-w-xl text-cream/70 font-light leading-relaxed">
                            Our philosophy of private guiding, reserved exclusively for the Bespoke Private Tour. Your
                            guide is always present and always ready — yet invisible the moment you want your own space.
                        </p>
                        <button
                            data-testid="teaser-bespoke-link"
                            onClick={() => navigate("/bespoke")}
                            className="mt-8 btn-ghost-light"
                        >
                            Discover the Philosophy
                        </button>
                    </Reveal>
                </div>
                <div className="lg:col-span-5" aria-hidden="true">
                    <Reveal delay={0.15}>
                        <div className="border border-gold/30 p-8 space-y-6">
                            <div>
                                <p className="text-[11px] tracking-[0.2em] uppercase text-gold mb-3">Present when you need us</p>
                                <span className="block h-px w-full bg-gold" />
                            </div>
                            <div>
                                <p className="text-[11px] tracking-[0.2em] uppercase text-cream/60 mb-3">Invisible when you don&rsquo;t</p>
                                <span className="block h-0 w-full border-t border-dashed border-gold/70" />
                            </div>
                            <p className="font-serif italic text-cream/80 text-sm pt-2">
                                Two lines, one philosophy — the solid line steps in, the dashed line steps back.
                            </p>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
